import { AuthGuard } from '@/auth/guard/auth.guard';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { HomeComponent } from './home.component';

export const homeChildRoutes = [
  {
    path: 'licenses',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/verification/licenses'),
  },
  {
    path: 'infractions',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/verification/infractions'),
  },
  {
    path: 'requests',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/verification/requests'),
  },
];
